import {useState} from "react";
import {type IObjectWithKey, Selection} from "@fluentui/react";
import type ConstructionListItem from "../../../types/ConstructionListItem";

const useConstructionsNewTableSelectionHook = (
  handleSelection: (selectedConstructions: ConstructionListItem[]) => void,
): Selection<IObjectWithKey> => {
  const [selection] = useState<Selection>(
    new Selection({
      onSelectionChanged: () => {
        const selected = selection.getSelection();
        const updatedConstructions = [...selected];

        handleSelection(updatedConstructions as ConstructionListItem[]);
      },
    }),
  );

  return selection;
};

export default useConstructionsNewTableSelectionHook;
